<template>
  <v-card class="py-3 px-3 mb-3">
    <div class="d-flex align-center justify-space-between mb-3">
      <h4 class="text-uppercase">{{ $vuetify.lang.t('$vuetify.labels.customer') }}</h4>
    </div>

    <div class="d-flex align-center mb-4">
      <CustomerCardImage :customerImage="customerImage"></CustomerCardImage>

      <div>
        <h4 class="text-uppercase">{{ customerName }}</h4>
        <div v-if="order.ordersCount">
          {{ $vuetify.lang.t(`$vuetify.labels.countOrdersDetail`) }}
          {{ order.ordersCount }}
        </div>
        <div class="lighten" v-if="order.customerId">
          {{ $vuetify.lang.t('$vuetify.labels.customerRegistered') }}
        </div>
        <div class="lighten" v-else>{{ $vuetify.lang.t('$vuetify.labels.customer') }}</div>
      </div>
    </div>
    <div>
      <div class="d-flex align-center">
        <v-icon color="primary" small>$vuetify.icons.envelope</v-icon>
        <span class="ml-3">{{ order.email }}</span>
      </div>
      <div class="d-flex align-center">
        <v-icon color="primary" small>$vuetify.icons.phone</v-icon>
        <span class="ml-3">{{ phoneNumber }}</span>
      </div>
    </div>
  </v-card>
</template>

<script>
import CustomerCardImage from '../../global/CustomerCardImage.vue';
import { OrdersApiService } from '../../../common/services/orders.api.service';
import { mapGetters } from 'vuex';

export default {
  components: {
    CustomerCardImage,
  },

  props: {
    customerImage: {
      type: String,
      default: null,
    },
  },

  computed: {
    ...mapGetters({
      getOrder: 'orders/getOrder',
      formLanguage: 'languages/formLanguage',
    }),

    order() {
      return this.getOrder(Number(this.$route.params.id));
    },

    formInitialData() {
      if (!this.order || !this.order.email) {
        return null;
      }

      return { email: this.order.email };
    },

    phoneNumber() {
      if (this.order.addresses) {
        const billingAddress = this.order.addresses.find(address => address.type === 2);
        return billingAddress.phone;
      }
      return this.$vuetify.lang.t('$vuetify.labels.notFilled');
    },

    customerName() {
      if (!this.order.addresses || !this.order.addresses.length) {
        return '-';
      }
      if (this.order.addresses[1]) {
        return `${this.order.addresses[1].firstName} ${this.order.addresses[1].lastName}`;
      }
      return `${this.order.addresses[0].firstName} ${this.order.addresses[0].lastName}`;
    },
  },

  methods: {
    saveData() {
      const formData = this.$refs.customerForm.save();

      if (!formData) {
        return;
      }

      OrdersApiService.patch(this.order.id, formData)
        .then(() => {
          this._openCloseDrawer(false);
          this.$emit('saved');
        })
        .catch(response => {
          this.$alertError(response.getFirstValidationErrorMessage() || response.getMessage());
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
